var _defs, _path, _g, _path2, _path3, _path4, _g2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWikimediaIconAdobe24943 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dadada",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f1f1",
    offset: 0.34923
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f0f0",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.85827,
    x2: 0.06299,
    y1: 0.14063,
    y2: 0.54688
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.05217,
    x2: 0.78261,
    y1: 0.97656,
    y2: 0.00781
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.09551,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.11905,
    x2: 0.86508,
    y1: 0.12245,
    y2: 0.80272
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#df421e",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#900",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.10968,
    x2: 0.63871,
    y1: 1.6061,
    y2: 0.38636
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.29752,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.88034,
    x2: 0.08547,
    y1: 0.21094,
    y2: 1.1797,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.63248,
    x2: -0.37607,
    y1: 0.32813,
    y2: 1.3281,
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.159 6.3293v146.96h134.11v-110.22l-33.528-36.739h-100.58z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.30417 0 0 .29757 -36.704 -112.49)",
    fill: "url(#d)",
    fillOpacity: 0.75,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m173.36 408.81v489.04h435.05v-366.78l-108.76-122.26h-326.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.12 407.19v493.91h441.53v-371.28c-36.847-41.423-73.68-82.859-110.56-124.25h-330.97v1.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.88 403.94v500.41h448.03v-375.78c-37.451-42.09-74.889-84.192-112.38-126.25h-335.66v1.625z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.29669 0 0 .29669 -71.196 -34.058)",
    d: "m297.99 136.74v495.32h452.02v-371.49l-113.01-123.83h-339.02z",
    fill: "url(#g)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeOpacity: 0.36478,
    strokeWidth: 1.4375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.29669 0 0 .29669 -71.196 -34.058)",
    d: "m750.01 260.57c-34.07-10.086-78.216-8.6561-111.57-2.9072 5.7583-36.949 6.478-83.255-1.4396-120.92l113.01 123.83z",
    fill: "url(#f)",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.29669 0 0 .29669 -71.196 -34.058)",
    d: "m301.31 174.91-2.0359 454h443.82l0.25448-112.23c-9.9248 3.8172-110.19-138.18-236.41-132.08-126.34 6.1131-93.649-191.37-205.62-209.69z",
    fill: "url(#e)",
    fillRule: "evenodd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1247 0 0 .82166 16.107 180.52)",
    fill: "url(#b)",
    fillOpacity: 0.22642
  }, /*#__PURE__*/React.createElement("path", {
    d: "m57.695-158.82c-2.9219 0.4286-4.522 1.5871-5.8723 6.492s-0.04381 13.735 1.8098 20.508c0.76032 2.2534 1.7489 4.4335 2.625 6.6562-0.50007 3.3527-1.1083 6.7045-1.9688 10-3.2826 13.457-7.0134 26.986-12.625 39.688-7.8159 3.8425-15.414 8.0987-22.625 12.969-4.3488 2.7264-12.309 10.38-5 14.406 4.1042 2.3266 8.3758 1.8563 12.25 0 1.9371-0.92817 3.7654-2.2274 5.4375-3.6562s3.2001-2.9964 4.4688-4.5625c3.9088-4.9269 7.2644-10.191 10.219-15.688 11.71-5.2634 23.8-9.6923 36.25-12.781 5.2057 4.5423 12.837 9.1164 19.312 4.5938 6.4919-2.9573 5.4037-11.732-2-11.844-4.9079-0.97662-9.7805-0.37323-14.594 0.71875-2.0981-2.4129-4.0458-5.0074-5.8438-7.4375-5.7972-9.2227-11.146-18.725-16.156-28.406 1.3572-8.879 2.7493-18.753 1.6604-25.17s-4.2286-6.9442-7.3479-6.4867zm-0.96875 6.6562c0.78729-1.7459 2.8165 0.10374 2.7816 2.4402s-0.40607 7.5669-2.0629 9.0286c-1.2374-3.7839-1.506-9.7229-0.71875-11.469zm4.3125 37.688c4.5575 9.0952 10.09 17.697 17 25.125-2.0364 0.58732-4.1148 1.1445-6.125 1.6562-7.4204 2.369-14.693 5.214-21.844 8.3438 5.08-11.175 8.4334-23.112 10.969-35.125zm31.406 27.938c2.6146-0.02498 4.7028 0.64099 4.1875 3.125-2.2042-0.56293-4.1245-1.6362-5.9375-2.9375 0.59273-0.06035 1.1869-0.18212 1.75-0.1875zm-54.438 18.5c-0.55667 1.0631-1.0024 2.172-1.5938 3.2188-3.7514 5.7513-9.1788 12.977-16.656 12.844-2.2333-6.2697 6.9211-9.7656 11.188-12.594 2.3252-1.209 4.7047-2.3152 7.0625-3.4688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.625-160.12c-7.613 1.2872-8.1394 10.75-7.2959 16.869 0.83892 6.2261 1.835 12.496 4.5459 18.225-3.3153 16.587-7.7944 32.962-14.281 48.625-9.9946 5.7328-21.228 10.304-29 19.062-2.6774 3.3906-2.2331 9.091 2.3619 10.513 8.0907 4.4214 17.184-1.6695 22.346-7.8841 4.8028-4.7564 7.4004-11.415 11.594-16.404 11.276-4.7521 22.721-8.834 34.479-12.225 5.5502 4.7098 14.202 8.9444 20.875 3.9062 6.2984-2.4687 5.1754-13.391-1.9025-13.699-5.0898-1.2526-10.294-0.3753-15.379 0.38666-8.6447-10.551-14.651-22.849-21.219-34.719 0.8448-9.8555 4.1134-20.627-0.25666-30.016-1.421-2.2649-4.3423-3.0608-6.8683-2.6401zm0.5 10.531c0.63366 6.845-1.525-1.0204 0 0zm9.4062 49c2.5834 3.6071 5.237 7.2348 8.1875 10.594-7.8866 2.2972-15.641 4.9349-23.188 8.1875 4.1518-9.3484 6.3798-19.362 8.9688-29.219l6.0312 10.438zm-35.156 39.125c-2.9673 3.5383-6.5454 7.3982-11.375 7.9688 0.83482-6.0172 7.9505-7.8523 12.389-10.843 4.2747-2.8889-0.83118 1.952-1.014 2.8746z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m78.743 17.879c-3.2863 0.48206-5.086 1.785-6.6048 7.3017s-0.04927 15.448 2.0356 23.066c0.85515 2.5345 1.967 4.9865 2.9524 7.4865-0.56244 3.7709-1.2466 7.5407-2.2143 11.247-3.6921 15.136-7.8882 30.352-14.2 44.638-8.7908 4.3218-17.337 9.1088-25.447 14.586-4.8912 3.0665-13.844 11.675-5.6236 16.203 4.6162 2.6168 9.4204 2.0879 13.778 0 2.1787-1.0439 4.2351-2.5052 6.1157-4.1123s3.5993-3.3701 5.0261-5.1316c4.3963-5.5414 8.1705-11.462 11.493-17.644 13.171-5.9199 26.769-10.901 40.771-14.375 5.855 5.1089 14.438 10.254 21.721 5.1667 7.3016-3.3262 6.0776-13.195-2.2494-13.321-5.5201-1.0984-11-0.41978-16.414 0.8084-2.3598-2.7139-4.5504-5.632-6.5726-8.3652-6.5203-10.373-12.536-21.061-18.171-31.949 1.5265-9.9865 3.0923-21.091 1.8675-28.309s-4.756-7.8104-8.2644-7.2957zm-1.0896 7.4865c0.88549-1.9636 3.1678 0.11668 3.1286 2.7445s-0.45672 8.5107-2.3202 10.155c-1.3917-4.2559-1.6939-10.936-0.8084-12.899zm4.8504 42.388c5.126 10.23 11.349 19.904 19.12 28.259-2.2904 0.66058-4.628 1.2872-6.889 1.8628-8.346 2.6644-16.525 5.8644-24.568 9.3844 5.7136-12.569 9.4853-25.995 12.337-39.506zm35.323 31.422c2.9408-0.0281 5.2894 0.72094 4.7098 3.5148-2.4791-0.63314-4.639-1.8403-6.6781-3.3039 0.66666-0.06788 1.3349-0.20483 1.9683-0.21089zm-61.227 20.807c-0.6261 1.1957-1.1274 2.4429-1.7925 3.6202-4.2193 6.4686-10.324 14.595-18.734 14.446-2.5119-7.0517 7.7844-10.984 12.583-14.165 2.6152-1.3598 5.2915-2.604 7.9434-3.9014z",
    fill: "url(#c)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWikimediaIconAdobe24943, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wikimedia_icon_Adobe-24943.84d9c255.svg";
export { ForwardRef as ReactComponent };